export default __webpack_public_path__ + "static/media/Rupan Headshot.985b68e0.jpeg";